import { Flex, IconButton, Tooltip } from '@vimeo/bokeh';
import { SearchMagnifierFilled } from '@vimeo/bokeh-icons';
import { CommentsContainer } from '@vimeo/comments-view';
import { translate } from '@vimeo/i18n-runtime';

import { LayoutToggle } from '../components/LayoutToggle';
import { ModuleHeader } from '../components/ModuleHeader';

interface Props {
  clipId: string | null;
  showcaseId: number;
  clipRequestId?: string;
}

export const CommentsModule = ({ clipId, clipRequestId, showcaseId }: Props) => {
  if (!clipId || !clipRequestId) return null;

  return (
    <Flex direction="column" w="100%" h="100%" data-testid="comments-module">
      <ModuleHeader text={translate('Comments')} count={0}>
        <SearchIconButton />
        <LayoutToggle />
      </ModuleHeader>
      <CommentsContainer
        clipRequestId={clipRequestId}
        clipId={clipId}
        isPublic
        searchQuery=""
        onMomentPlay={() => undefined}
        showcaseId={showcaseId}
      />
    </Flex>
  );
};

export const SearchIconButton = ({ onClick }: { onClick?: () => void }) => (
  <Tooltip label={translate('Search')} placement="top">
    <IconButton
      size="sm"
      variant="tertiary"
      icon={<SearchMagnifierFilled />}
      aria-label={translate('Search')}
      onClick={onClick}
    />
  </Tooltip>
);
